import { handleActions } from 'redux-actions';
import { LOADING } from '../actionTypes';
import { ui } from '../initialState';

export default handleActions(
  {
    [LOADING]: (state, action) => {
      return {
        ...state,
        loadingBar: action.payload
      };
    }
  },
  ui
);
